import { render } from "./examPointHome.vue?vue&type=template&id=24ad44e4&scoped=true"
import script from "./examPointHome.vue?vue&type=script&lang=js"
export * from "./examPointHome.vue?vue&type=script&lang=js"

import "./examPointHome.vue?vue&type=style&index=0&id=24ad44e4&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad44e4"]])

export default __exports__